import { render } from "./dropzone.vue?vue&type=template&id=220207cb&scoped=true"
import script from "./dropzone.vue?vue&type=script&lang=js"
export * from "./dropzone.vue?vue&type=script&lang=js"

import "./dropzone.vue?vue&type=style&index=0&id=220207cb&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-220207cb"]])

export default __exports__